import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=652a92d3&scoped=true&"
import script from "./resume.vue?vue&type=script&lang=ts&"
export * from "./resume.vue?vue&type=script&lang=ts&"
import style0 from "./resume.vue?vue&type=style&index=0&id=652a92d3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a92d3",
  null
  
)

export default component.exports